import { i18nLike } from "#web/services/i18nLike";
import { useAppBridge } from "@shopify/app-bridge-react";
import { BlockStack, Button, ButtonGroup, Card, Text } from "@shopify/polaris";

const en = {
  contactUs: "Contact us",
  copied: "Email address copied to clipboard",
  documentation: "Open documentation",
  subtitle:
    "Need help? Our support team is ready to assist with technical questions, setup guidance, and troubleshooting.",
  title: "Get Support",
};

export const SupportCard = () => {
  const t = i18nLike(en);
  const shopify = useAppBridge();

  const handleContactUs = () => {
    void navigator.clipboard.writeText("support@keepcart.co");
    shopify.toast.show(t("copied"), {
      duration: 4000,
    });
  };

  return (
    <Card>
      <BlockStack gap="100">
        <Text as="h3" variant="headingMd">
          {t("title")}
        </Text>
        <BlockStack gap="300">
          <Text as="p" variant="bodyMd">
            {t("subtitle")}
          </Text>
          <ButtonGroup>
            <Button onClick={() => window.open("https://www.keepcart.co/docs", "_blank")} variant="secondary">
              {t("documentation")}
            </Button>
            <Button onClick={handleContactUs} variant="primary">
              {t("contactUs")}
            </Button>
          </ButtonGroup>
        </BlockStack>
      </BlockStack>
    </Card>
  );
};
